// Fusión de las dos fuentes de Pedidos de venta.
//
// Fabric es la base (histórico, importes, facturas) pero va ~15 min por detrás
// de F&O. El overlay de Dataverse es una lectura en vivo de lo creado en las
// últimas horas, así que para los campos que expone siempre es más fresco.
import type { PedidoVentaRow } from '@/types'

/** Campos que Dataverse conoce y Fabric puede tener obsoletos. */
const CAMPOS_DATAVERSE = [
  'custaccount',
  'nombreCliente',
  'fechaEntrega',
  'salesstatus',
] as const

const claveDe = (r: PedidoVentaRow) => `${r.dataareaid}|${r.salesid}`

/** Fusiona Fabric (base) con el overlay (Dataverse).
 *
 *  - En ambos    → fila de Fabric con los campos de Dataverse pisados encima.
 *                  pendienteSync queda en false: Fabric ya tiene el pedido.
 *  - Sólo DV     → fila nueva marcada como pendiente de sincronizar, al principio.
 *  - Sólo Fabric → intacta.
 */
export function mergePedidos(
  fabric: PedidoVentaRow[],
  overlay: PedidoVentaRow[],
): PedidoVentaRow[] {
  if (overlay.length === 0) return fabric

  const porClave = new Map(overlay.map(r => [claveDe(r), r]))
  const fusionadas = fabric.map(f => {
    const dv = porClave.get(claveDe(f))
    if (!dv) return f
    porClave.delete(claveDe(f))
    const frescos: Partial<PedidoVentaRow> = {}
    for (const campo of CAMPOS_DATAVERSE) {
      const valor = dv[campo]
      if (valor !== undefined && valor !== null && valor !== '') {
        frescos[campo] = valor
      }
    }
    return { ...f, ...frescos, pendienteSync: false }
  })

  // Lo que queda en el mapa no está en Fabric todavía: va primero, que es lo
  // que el usuario acaba de crear.
  return [...porClave.values(), ...fusionadas]
}
